import { useNavigate, useSearchParams } from "react-router-dom";
import ExitLoader from "./exit-loader";
import ProfileCongratsScreen from "../../components/profile-update-screen/profile-congrats-screen";
import { KEY_RETURN_TO_POST_ONBOARDING } from "../../shared/constants";
import { useEffect } from "react";
import { httpClient } from "../../shared/http-client";
import { NOTIFY_ONBOARDING_COMPLETED } from "../../shared/constants/URLS";
import NewProfileSuceesScreen from "../../components/profile-update-screen/NewProfileSuceesScreen";

export const Exit = () => {
    const [params] = useSearchParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (params.get("source") === "rrnr") {
            httpClient.put(NOTIFY_ONBOARDING_COMPLETED, {
                is_revised_rnr_completed: true,
            })
        }
    }, [])

    return params.get("source") === "rrnr" ? <ExitLoader /> : <NewProfileSuceesScreen />
}
